import { render, staticRenderFns } from "./LogoLoading.vue?vue&type=template&id=f89f39fc&scoped=true"
var script = {}
import style0 from "./LogoLoading.vue?vue&type=style&index=0&id=f89f39fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89f39fc",
  null
  
)

export default component.exports